import React from 'react'
import { useQuery } from '@tanstack/react-query'
import RewardsAPI from 'api/faber/RewardsAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import format from 'date-fns/format'
import OrbitSession from 'hooks/useCookies'

const promocodeColumns = [
  {
    field: 'CreatedAt',
    headerName: 'Timestamp',
    sortable: false,
    minWidth: 150,
    valueFormatter: ({ value }) =>
      value ? format(new Date(value), 'dd MMM yyyy HH:mm') : ''
  },
  {
    field: 'promocode',
    headerName: 'Promocode',
    sortable: false,
    minWidth: 100
  },
  {
    field: 'rewardName',
    headerName: 'Reward Name',
    sortable: false,
    minWidth: 300
  },
  {
    field: 'claimedAt',
    headerName: 'Claimed on',
    sortable: false,
    minWidth: 100,
    valueFormatter: ({ value }) =>
      value ? format(new Date(value), 'dd MMM yyyy HH:mm') : ''
  },
  {
    field: 'consumedAt',
    headerName: 'Redeemed On',
    sortable: false,
    minWidth: 100,
    valueFormatter: ({ value }) => {
      if (value === 0) {
        return 'AVAILABLE'
      } else {
        return format(new Date(value), 'dd MMM yyyy HH:mm')
      }
    }
  },

  {
    field: 'promocodeType',
    headerName: 'Promocode Type',
    sortable: false,
    minWidth: 100
  }
]

function PromocodesDisplayForOneUser({ userId }: { userId: string }) {
  const faberToken = OrbitSession.get('faberToken')

  const { data: allPromocodesData } = useQuery(
    ['get-all-promocodes-one-user', userId],
    async () => {
      return RewardsAPI.getAllPromocodesForOneUser({
        userId,
        faberToken
      })
    }
  )

  return (
    <>
      <MUIDataGrid
        columns={promocodeColumns}
        rows={allPromocodesData ? allPromocodesData.body.data : []}
        getRowId={(row) => row.ID}
      />
    </>
  )
}

export default PromocodesDisplayForOneUser
